<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <card v-if="grants.length" v-for="grant in grants" v-bind:key="grant.grantId">
          <template slot="header">
            <h3 class="card-title">{{ grant.description }}</h3>
          </template>
          <div>
            <base-button v-if="!grant.applied && grant.locked" disabled type="primary" size="lg" simple>{{ $t('grants.proposals_closed') }}</base-button>
            <base-button v-if="!grant.applied && !grant.locked" @click="applyFor(grant.grantId)" type="primary" size="lg" simple>{{ $t('grants.apply') }}</base-button>
            <base-button v-if="grant.applied" disabled type="primary" size="lg" simple>{{ $t('grants.already_applied') }}</base-button>
          </div>
        </card>

        <card v-if="initialized && !grants.length">
          <h3 class="card-title">
            {{ $t('grants.empty_state') }}
          </h3>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import {GrantService} from '@/services';

  export default {
    data() {
      return {
        initialized: false,
        grants: []
      };
    },
    methods: {
      applyFor(grantId) {
        this.$router.push('/application/fill/' + grantId);
      },
      async getList() {
        let loader = this.$loading.show();
        GrantService.all().then((response) => {
          this.grants = response.data;
          this.initialized = true;
          loader.hide();
        })
      }
    },
    created() {
      this.getList();
    }
  };
</script>
<style lang="scss"></style>
